import { VaporHeaderBar, VaporHeaderBarProps } from "../VaporHeaderBar";
export const Title = VaporHeaderBar;
export interface TitleProps extends VaporHeaderBarProps {}
